"use client"

import React, { useState } from 'react'
import RenderTableOfContent from './RenderTableOfContent'
import { NestHeadings } from './NestHeadings'
import { PortableTextBlock } from 'next-sanity'

const TableOfContents = ({ tableOfContents }: { tableOfContents: PortableTextBlock[] }) => {
    const [scrollTitle, setScrollTitle] = useState<string | null>(null);

    return (
        <div className="sticky self-start top-[120px] w-full lg:w-[287px] hidden lg:flex flex-col gap-5">
            <h3 className="text-xl font-semibold mb-2 text-gray-900">
                {`Table of Contents`}
            </h3>
            <div className="flex gap-4 max-h-[600px] overflow-y-auto">
                <RenderTableOfContent
                    elements={NestHeadings(tableOfContents)}
                    scrollTitle={scrollTitle}
                    setScrollTitle={setScrollTitle}
                />
            </div>
        </div>
    )
}

export default TableOfContents